/* eslint-disable react/prop-types */
import React from "react";
import { Button } from "react-bootstrap";
import { Description } from "./styles";

const Info = ({ data: marca }) => {
  // const country = process.env.REACT_APP_COUNTRY;

  const renderDescriptionArray = (descripcionArray) => {
    if (!Array.isArray(descripcionArray) || descripcionArray.length === 0) {
      return "Descripción del producto no disponible";
    }

    return (
      <ul className="list-disc pl-5">
        {descripcionArray
          .filter((item) => item.trim() !== "")
          .map((item, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
      </ul>
    );
  };

  // Funcion para formatear y renderizar Descripcion_corta (en caso de no ser ARG)
  // const formatDescription = (description) => {
  //   return { __html: description.replace(/\n/g, "<br />") };
  // };

  const handleDownload = () => {
    const fileName = marca.Manual_Tecnico;

    if (fileName) {
      const fileUrl = `${process.env.PUBLIC_URL}/articulos/${encodeURIComponent(fileName)}`;

      // Crear un enlace para descargar el archivo
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileName;

      link.target = "_blank";
      link.click();
    } else {
      alert("El archivo no está disponible.");
    }
  };

  // Función para detectar si es un link de YouTube y extraer el ID
const getYouTubeId = (url) => {
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url?.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

  

  return (
    <Description>
      <div>
        <span>{marca.Nombre}</span>
        <hr />
        <br />

        {marca.descripcionArray ? (
          <div>{renderDescriptionArray(marca.descripcionArray)}</div>
        ) : (
          <p>Descripción del producto no disponible</p>
        )}
        <br />

        {marca.Video ? (
          marca.Video.startsWith("https://www.youtube.com/embed/") ? (
            <div className="video-responsive">
              <iframe
                width="100%"
                height="315"
                src={marca.Video}
                title="YouTube video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <span>Video: {marca.Video}</span>
          )
        ) : (
          <span></span>
        )}



        {/* Verificar si marca.Manual_Tecnico existe y no es null */}
        {marca.Manual_Tecnico && marca.Manual_Tecnico !== null && (
          <div className="text-center mt-4">
            <Button
              variant="outline-primary"
              className="rounded-pill"
              onClick={handleDownload}
            >
              Descargar Manual Técnico
            </Button>
          </div>
        )}
      </div>
    </Description>
  );
};

export default Info;
